/**
 * Mega Menu - Desktop & Mobile Interactions
 * nanoblock.com.au
 */
(function() {
  'use strict';

  /* ---------- Desktop: Hover to open mega panels ---------- */
  function initDesktopMegaMenu() {
    var items = document.querySelectorAll('.mega-menu-item.has-mega-panel');
    var closeTimer = null;

    items.forEach(function(item) {
      item.addEventListener('mouseenter', function() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        // Close all other panels
        items.forEach(function(other) {
          if (other !== item) other.classList.remove('is-open');
        });
        item.classList.add('is-open');
      });

      item.addEventListener('mouseleave', function() {
        closeTimer = setTimeout(function() {
          item.classList.remove('is-open');
        }, 150);
      });

      // Keyboard: open on focus, close on blur
      var link = item.querySelector('.mega-menu-link');
      if (link) {
        link.addEventListener('focus', function() {
          items.forEach(function(other) {
            other.classList.remove('is-open');
          });
          item.classList.add('is-open');
        });
      }

      // Close on Escape key
      item.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          item.classList.remove('is-open');
          var link = item.querySelector('.mega-menu-link');
          if (link) link.focus();
        }
      });
    });

    // Close all panels when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.mega-menu-item')) {
        items.forEach(function(item) {
          item.classList.remove('is-open');
        });
      }
    });
  }

  /* ---------- Mobile: Accordion toggles ---------- */
  var mobileInitialized = false;

  function initMobileMegaMenu() {
    // Only bind if toggles exist in the live DOM (not inside script template)
    var toggles = document.querySelectorAll('body > .mobile-mega-nav .mobile-mega-toggle');
    if (toggles.length === 0) return;
    if (mobileInitialized) return;
    mobileInitialized = true;

    toggles.forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        var expanded = toggle.getAttribute('aria-expanded') === 'true';

        // Close all other submenus (accordion behavior)
        toggles.forEach(function(other) {
          if (other !== toggle) {
            other.setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle current
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });
  }

  /* ---------- Initialize ---------- */
  function init() {
    initDesktopMegaMenu();
    initMobileMegaMenu();
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Watch for the mobile nav being dynamically injected into the body
  // (Canopy theme extracts it from a <script type="text/template"> tag)
  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var node = mutations[i].addedNodes[j];
        if (node.nodeType === 1 && (node.classList.contains('mobile-mega-nav') || node.querySelector && node.querySelector('.mobile-mega-nav'))) {
          initMobileMegaMenu();
          observer.disconnect();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Fallback: retry after a short delay in case mutation was missed
  setTimeout(function() {
    if (!mobileInitialized) initMobileMegaMenu();
  }, 1500);

  // Also re-init after Shopify section rendering (for theme editor compatibility)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      mobileInitialized = false;
      init();
    });
  }
})();
